import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule }   from '@angular/forms';
import {
	BlockUIModule,
	EditorModule,
	DialogModule
} from 'primeng/primeng';
import { CKEditorModule } from 'ng2-ckeditor';

import { EmailDialogComponent } from './email-dialog.component';

@NgModule({
  imports: [
    CommonModule,
	TranslateModule,
	RouterModule,
	NgbModule.forRoot(),
	BlockUIModule,
	EditorModule,
	DialogModule,
	FormsModule,
	CKEditorModule
  ],
  declarations: [EmailDialogComponent],
  exports: [EmailDialogComponent]
})
export class EmailDialogModule { }



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/modules/email-dialog/email-dialog.module.ts